import React from "react";

export const RatingStarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.72656 13.7292L8.9974 11.7708L12.2682 13.75L11.3932 10.0417L14.2682 7.54167L10.4766 7.20833L8.9974 3.70833L7.51823 7.1875L3.72656 7.52083L6.60156 10.0208L5.72656 13.7292ZM3.85156 16.3333L5.20573 10.4792L0.664062 6.54167L6.66406 6.02083L8.9974 0.5L11.3307 6.02083L17.3307 6.54167L12.7891 10.4792L14.1432 16.3333L8.9974 13.2292L3.85156 16.3333Z"
      fill="#545454"
    />
  </svg>
);
